/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Entry/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Action from './Action/index'
import Author from './Author/index'
import Datetime from './Datetime/index'
import LineToNextPoint from './LineToNextPoint/index'
import Point from './Point/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Entry({
  children,
  viewPath = "/DesignSystem/AppointmentHistory/Content/Entry"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Entry.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Entry.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Point
  viewPath={`${viewPath}/Point`}
/>
<LineToNextPoint
  viewPath={`${viewPath}/LineToNextPoint`}
/>
</div>
<div
  data-testid="Entry.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-1-4PFPn': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--mr-2-4PFPn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<Action
  viewPath={`${viewPath}/Action`}
/>
<Author
  viewPath={`${viewPath}/Author`}
/>
<Datetime
  viewPath={`${viewPath}/Datetime`}
/>
</div>
</div>
{children}
</React.Fragment>)
}